import { OrganisationHeaderWithImage } from '@percent/lemonade';
import { OrganisationPreviewProps } from './OrganisationPreview.types';
import styles from './OrganisationPreview.module.scss';
import { useTranslation } from 'react-i18next';

export function OrganisationPreview({ organisation }: OrganisationPreviewProps) {
  const { name, countryCode, logo, address, postcode, registryId } = organisation;

  const { t } = useTranslation();

  return (
    <div className={styles.organisationPreview} key={name} data-testid="organisation-preview">
      <OrganisationHeaderWithImage
        title={name}
        countryCode={countryCode}
        iconUrl={logo}
        registryId={`${t('hostedValidation.typography.registeredNumber')}: ${registryId}`}
      />
      <span className={styles.organisationPreviewAddress} data-testid="organisation-preview-address">
        {[address, postcode].filter(Boolean).join(', ')}
      </span>
    </div>
  );
}
